import { Observable } from "rxjs";

export class FileHelper {
    static downloadFromObservable(blobResult: Observable<{ filename: string, blob: Blob }>) {
        blobResult.subscribe(res => {
            FileHelper.download(res);
        });
    }

    static download(blobResult: { filename: string, blob: Blob }) {
            const data = window.URL.createObjectURL(blobResult.blob);

            var link = document.createElement('a');
            link.href = data;
            link.download = blobResult.filename;
            // this is necessary as link.click() does not work on the latest firefox
            link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
                link.remove();
            }, 100);
    }
}